import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

// import { ILogin } from "src/app/interfaces/login";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IRegister } from "src/app/interfaces/register";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { CountdownComponent } from "ngx-countdown";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { HidService } from "src/app/services/common/hid.service";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-registration-confirm",
  templateUrl: "./registration-confirm.component.html",
  styleUrls: ["./registration-confirm.component.css"],
  providers: [ErrorsService]
})
export class RegistrationConfirmComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  timer = 0;
  form: FormGroup;
  password: string;
  errors = new Array();
  nationalCode: string;
  cellPhoneNumber: string;
  activeteTimeOut: boolean = false;
  registerFormData: IRegister;
  codemask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  @ViewChild("countdown") counter: CountdownComponent;
  returnNapto = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private hidService: HidService,
    private holdingService: HoldingService,
    private errorService: ErrorsService,
    private titleService: Title,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    debugger
    this.activeRoute.params.subscribe(params => {
      if (params['name'] && params['name'] == 'napto') {
        this.returnNapto = true;
      }
    })

    this.titleService.setTitle(environment.siteTitle);
    this.accountService.currentFormData.subscribe(
      formData => (
        (this.registerFormData = formData),
        (this.cellPhoneNumber = formData.CellPhoneNumber),
        (this.nationalCode = formData.NationalCode),
        (this.password = formData.Password),
        (this.timer = formData.timer)
      )
    );
    // if (!this.timer) {
    //   this.router.navigate(["login"]);
    // }
    this.form = this.fb.group({
      NationalCode: [null],
      ActivateCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("[0-9]{6}"),
          Validators.maxLength(10)
        ])
      ]
    });
  }

  onFinished() {
    this.activeteTimeOut = true;
  }


  resendCode() {
    this.errors = new Array();
    var data = {
      NationalCode: this.nationalCode
    };
    this.accountService.resendCode(data).subscribe(
      res => {
        this.counter.restart();
        this.timer = res.returnValue * 60;
        this.activeteTimeOut = false;
        this.snackBar.OpenSnackBar(
          this.translate.get("success.confirmationCodeHasBeenSent"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
  // getAllHolding() {
  //   this.holdingService.allList().subscribe(res => {
  //     this.hidService.setHID(res.DataList[0].HoldingEncryptCode);
  //   });
  // }
  submit(data: any) {
    let _this = this;
    var loginData: any = {
      nationalCode: this.nationalCode,
      password: this.password
    };
    this.errors = new Array();
    data.NationalCode = this.nationalCode;
    this.holdingService.allList().subscribe(res => {
      this.hidService.setHID(res.DataList[0].HoldingEncryptCode);
    });
    if (this.registerFormData.hasbeenRegisterd) {
      this.registerFormData.ActivateCode = data.ActivateCode;
      this.accountService.register(this.registerFormData).subscribe(() => {
        this.accountService.login(loginData).subscribe(res => {
          const user: any = res;
          setTimeout(() => {
            if (user) {
              localStorage.setItem("token", user.token);
              if (localStorage.getItem("token")) this.router.navigateByUrl("");
              this.snackBar.OpenSnackBar(
                this.translate.get("success.registration"),
                "ok",
                3000,
                SoundEnum.beep
              );

            }
          }, 2000);
          this.snackBar.OpenSnackBar(
            this.translate.get("label.dataValidation"),
            "ok",
            1500,
            SoundEnum.beep
          );
        });
      });
    } else {
      this.accountService.confirm(data).subscribe(
        () => {
          this.accountService.login(loginData).subscribe(res => {
            const user: any = res;
            setTimeout(() => {
              if (user) {
                localStorage.setItem("token", user.token);
                this.snackBar.OpenSnackBar(
                  this.translate.get("success.registration"),
                  "ok",
                  3000,
                  SoundEnum.beep
                );
                if (!_this.returnNapto) {
                  if (localStorage.getItem("token"))
                    this.router.navigateByUrl("");
                }
                else {
                  window.location.href = 'https://panel.gosafir.com/';
                }

              }
            }, 2000);
            this.snackBar.OpenSnackBar(
              this.translate.get("label.dataValidation"),
              "ok",
              1500,
              SoundEnum.beep
            );
          });
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
